import styled from 'styled-components';

export const ModalContent = styled.div`
  color: ${(props) => props.theme.colors?.greys.darker};
  font: ${(props) => props.theme.fonts?.textBigHeight24};
`;
